import { useEffect, useState } from "react";
import "./page.css";

const empty = {
  name: "",
  email: "",
  travelers: "2",
  message: "",
};

function Contact() {
  const [form, setForm] = useState(empty);
  const [sent, setSent] = useState(false);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    document.title = "Contact · Mirrorkhan Tours";
  }, []);

  function update(event) {
    const { name, value } = event.target;
    setForm((current) => ({ ...current, [name]: value }));
  }

  function submit(event) {
    event.preventDefault();
    const next = {};
    if (!form.name.trim()) next.name = "Please add your name.";
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email.trim())) {
      next.email = "Please add a valid email.";
    }
    if (!form.message.trim()) next.message = "Tell us a little about the trip.";
    setErrors(next);
    if (Object.keys(next).length) return;
    setSent(true);
  }

  return (
    <section className="page section-block">
      <div className="container">
        <div className="row g-4 g-lg-5 align-items-start">
          <div className="col-lg-5" data-reveal>
            <p className="eyebrow">Contact</p>
            <h1 className="mb-3">Tell us when you can travel.</h1>
            <p className="page-lead mb-0">
              Share a month, group size, and the kind of days you want. We reply
              within two working days.
            </p>
          </div>

          <div className="col-lg-7" data-reveal="right">
            {sent ? (
              <div className="form-success" role="status">
                <p className="eyebrow">Received</p>
                <h2 className="h3 mb-2">
                  Thank you, {form.name.trim().split(" ")[0]}.
                </h2>
                <p className="mb-4">
                  A planner will write to {form.email.trim()} with next steps.
                </p>
                <button
                  type="button"
                  className="btn btn-mk-gold"
                  onClick={() => {
                    setSent(false);
                    setForm(empty);
                  }}
                >
                  Send another note
                </button>
              </div>
            ) : (
              <form className="form-panel" onSubmit={submit} noValidate>
                <div className="row g-3">
                  <div className="col-md-6">
                    <label className="form-label" htmlFor="name">
                      Name
                    </label>
                    <input
                      id="name"
                      name="name"
                      className="form-control"
                      value={form.name}
                      onChange={update}
                      autoComplete="name"
                    />
                    {errors.name && (
                      <div className="field-error mt-1">{errors.name}</div>
                    )}
                  </div>
                  <div className="col-md-6">
                    <label className="form-label" htmlFor="email">
                      Email
                    </label>
                    <input
                      id="email"
                      name="email"
                      type="email"
                      className="form-control"
                      value={form.email}
                      onChange={update}
                      autoComplete="email"
                    />
                    {errors.email && (
                      <div className="field-error mt-1">{errors.email}</div>
                    )}
                  </div>
                  <div className="col-md-6">
                    <label className="form-label" htmlFor="travelers">
                      Travelers
                    </label>
                    <select
                      id="travelers"
                      name="travelers"
                      className="form-select"
                      value={form.travelers}
                      onChange={update}
                    >
                      {Array.from({ length: 8 }, (_, i) => String(i + 1)).map(
                        (n) => (
                          <option key={n} value={n}>
                            {n}
                          </option>
                        )
                      )}
                    </select>
                  </div>
                  <div className="col-12">
                    <label className="form-label" htmlFor="message">
                      What should we know?
                    </label>
                    <textarea
                      id="message"
                      name="message"
                      className="form-control"
                      value={form.message}
                      onChange={update}
                      rows="5"
                    />
                    {errors.message && (
                      <div className="field-error mt-1">{errors.message}</div>
                    )}
                  </div>
                  <div className="col-12">
                    <button className="btn btn-mk-gold" type="submit">
                      Send to the desk
                    </button>
                  </div>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
